<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item href="#important" active>Important</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">Important</h1>
    <p>Jump to your most important tasks.</p>
    <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold">
      <b-tab title="Personal List">
        <div class="task-container">
          <div v-if="showPlaceholderImagePersonal && !hideWhenInitialLoadPersonal" class="no-task-container">
            <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
                   alt="No task picture"></b-img>
            <h2>No important task</h2>
            <p>High priority task will be shown here</p>
          </div>
          <regular-with-origin-task-cell v-else v-for="importantTask in personalImportantTaskDocuments"
                                         :key="importantTask.taskId"
                                         :task-details="importantTask"></regular-with-origin-task-cell>
        </div>
      </b-tab>
      <b-tab title="Collaborative List">
        <div class="task-container">
          <div v-if="showPlaceholderImageCollaborative&& !hideWhenInitialLoadCollaborative" class="no-task-container">
            <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
                   alt="No task picture"></b-img>
            <h2>No important task</h2>
            <p>High priority task will be shown here</p>
          </div>
          <regular-with-origin-task-cell v-else v-for="importantTask in collaborativeImportantTaskDocuments"
                                         :key="importantTask.taskId"
                                         :task-details="importantTask"></regular-with-origin-task-cell>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import RegularWithOriginTaskCell from "../table_cells/task_cells/RegularWithOriginTaskCell"
  import {mapActions} from "vuex";
  import {db} from "../../main";

  export default {
    data() {
      return {
        showPlaceholderImagePersonal: null,
        showPlaceholderImageCollaborative: null,
        hideWhenInitialLoadPersonal: true,
        hideWhenInitialLoadCollaborative: true,
        personalImportantTaskDocuments: null,
        collaborativeImportantTaskDocuments: null
      }
    },
    components: {
      regularWithOriginTaskCell: RegularWithOriginTaskCell
    },
    methods: {
      ...mapActions([
        "updateListCategory"
      ]),
      getImportantTaskData() {
        this.$bind(
          'personalImportantTaskDocuments',
          db
            .collectionGroup('tasks')
            .where('assigneeId', '==', this.$store.getters.user.data.id)
            .where('taskType', '==', 'Personal Task')
            .where('priority', '==', 0)
            .orderBy('taskName', 'asc')
        ).then(() => {
          if (this.personalImportantTaskDocuments.length === 0) {
            this.showPlaceholderImagePersonal = true
          }
          this.hideWhenInitialLoadPersonal = false
        })

        this.$bind(
          'collaborativeImportantTaskDocuments',
          db
            .collectionGroup('tasks')
            .where('assigneeId', '==', this.$store.getters.user.data.id)
            .where('taskType', '==', 'Collaborative Task')
            .where('priority', '==', 0)
            .orderBy('taskName', 'asc')
        ).then(() => {
          if (this.collaborativeImportantTaskDocuments.length === 0) {
            this.showPlaceholderImageCollaborative = true
          }
          this.hideWhenInitialLoadCollaborative = false
        })
      }
    },
    watch: {
      personalImportantTaskDocuments(newProperties, oldProperties) {
        this.showPlaceholderImagePersonal = this.personalImportantTaskDocuments.length === 0
      },
      collaborativeImportantTaskDocuments(newProperties, oldProperties) {
        this.showPlaceholderImageCollaborative = this.collaborativeImportantTaskDocuments.length === 0
      },
    },
    mounted() {
      this.getImportantTaskData()
    }
  }
</script>

<style scoped>
  .no-task-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-task-picture {
    width: 375px;
    margin-bottom: 1em;
  }

  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .task-container {
    height: 65vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }
</style>
